import VisitsList from '@features/visits/components/visits-list/visits-list';
import { VisitListApplyFilter } from '@shared/entity';

const VisitsPage = (props: { type: VisitListApplyFilter }) => {
  return <VisitsList showFiltersFor={props.type} type={props.type} />;
};

export default VisitsPage;
